import { useTranslation } from "react-i18next";
import EmptyFilteredState from "../../images/EmptyFilteredState";

export const AnalyticsEmptyFilteredState = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center mt-8 text-gray-600">
      <div className="mb-4 flex justify-center">
        <EmptyFilteredState />
      </div>
      {t(
        "Pages.Analytics.Common.NoFilteredData",
        "There isn't any data for your selected filters.",
      )}
      <br />
      {t(
        "Pages.Analytics.Common.AdjustFilters",
        "Please adjust them and try again.",
      )}
    </div>
  );
};
